// extracted by css-extract-rspack-plugin
export default {"flags":"DtZkA5"};